import Canvas from './Canvas';
import withOptions from './withOptions';

export default withOptions()(Canvas);
